<template>
  <AiChat
    :open="visible"
    @on-close="handleCancel"
    :hideAiChat="true"
    :title="nodeDetail && nodeDetail.id ? '编辑LLM Pro节点' : '增加LLM Pro节点'"
  >
    <div class="common-container">
      <Form
        style="width: 100%"
        :model="formData"
        ref="form"
        :label-width="110"
        :rules="ruleValidate"
      >
        <FormItem label="节点名称" prop="name">
          <Input v-model="formData.name" style="width: 300px" />
        </FormItem>
        <FormItem label="话术ID" prop="agentid">
          <Input v-model="formData.agentid" style="width: 300px" />
        </FormItem>
        <FormItem label="IP地址" prop="trunk_ip">
          <Input v-model="formData.trunk_ip" style="width: 300px" />
        </FormItem>
        <div class="btn">
          <Button style="margin-right: 20px" color="#547ed1" @click="handleCancel">
            取消
          </Button>
          <Button
            type="primary"
            style="margin-right: 20px"
            color="#547ed1"
            @click="handleSubmit"
          >
            确定
          </Button>
        </div>
      </Form>
    </div>
  </AiChat>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import AiChat from '@/views/aiChat/index';

export default {
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: ['visible', 'nodeDetail'],
  components: {
    AiChat,
  },
  data() {
    return {
      formData: {
        name: '',
        agentid: '',
        trunk_ip: '',
      },
      ruleValidate: {
        name: [{ required: true, message: '节点名不能为空', trigger: 'blur' }],
        agentid: [{ required: true, message: '话术ID不能为空', trigger: 'blur' }],
        trunk_ip: [{ required: true, message: 'IP地址不能为空', trigger: 'blur' }],
      },
    };
  },
  watch: {
    nodeDetail(val) {
      if (!val) {
        this.resetForm();
        return;
      }
      this.formData = {
        ...this.formData,
        ...cloneDeep(val),
      };
    },
  },
  methods: {
    getDraft() {
      return cloneDeep(this.formData);
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const data = {
          ...cloneDeep(this.formData),
          // 直接生成 thirdllm 节点
          type: 'thirdllm',
        };
        if (this.formData.id) {
          this.$emit('editNode', data);
        } else {
          this.$emit('addNode', data);
        }
        this.handleCancel();
      });
    },
    handleCancel() {
      try {
        this.resetForm();
      } catch (e) {
        // resetFields 可能在表单销毁时抛错，忽略
        // console.log(e);
      }
      this.$emit('change', false);
      this.$emit('cancel');
    },
    resetForm() {
      this.$refs.form && this.$refs.form.resetFields();
      this.formData = {
        name: '',
        agentid: '',
        trunk_ip: '',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.common-container {
  padding: 10px;
  display: flex;
}
.btn {
  text-align: right;
  margin-top: 20px;
}
</style>

